import styled from "@emotion/styled";
import { type MantineTheme, Text, type TextProps } from "@mantine/core";

interface ReviewTextProps extends TextProps {
  blue?: boolean | string | null;
  red?: boolean | string | null;
  green?: boolean | string | null;
  disabled?: boolean;
  theme?: MantineTheme;
  color?: string;
}

export const ReviewText = styled(Text)`
  ${({
    blue,
    red,
    green,
    disabled,
    theme,
    color: propColor,
  }: ReviewTextProps) => {
    let color = propColor || "";
    blue = blue ?? color === "blue";
    red = red ?? color === "red";
    green = green ?? color === "green";
    if (theme) {
      color = theme.colors.defaultColor as unknown as string;

      if (blue) {
        color = theme.colors.settingsColor[0];
      } else if (red) {
        color = theme.colors.redText[0];
      } else if (green) {
        color = "green";
      } else if (disabled) {
        color = theme.colors.grayText[0];
      }
    }

    return `color: ${color};`;
  }}
`;

export const StatusGoldCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.summaryStatusGold[0]};
  color: ${({ theme }) => theme.colors.summaryStatusGold[0]};
  font-weight: bold;
`;
